export interface Exists<T> {
  data: T;
  exists: boolean;
}
